import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Loader from './../shared/loader'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import inwardlist from '../inwardlist';
import inward from '../inward';
import inwardEdit from '../inwardEdit';
import common_helper from '../../../common_helper';
import BarGraph from './charts.js'
import { BasicSelect } from 'vue-search-select'
import GRC from '../GRC1'
import VueFab from 'vue-float-action-button'
import Float from '../../components/float.vue'
import Vue from 'vue'

Vue.use(VueFab)

new Vue({
  render: h => h(Float)
}).$mount('#float')

import {
  Validator
} from 'vee-validate'


export default {
  name: 'config',
  components: {
    Loader,
    'step-progress': StepProgress,
    inwardlist,
    inward,
    inwardEdit,
    BasicSelect,
    BarGraph,
    GRC,
    VueFab,
    Float
  },
  props: [],
  data() {
    return {
      mrpchecknew: '',
      expirycheck: '',
      recordToDelete: '',
      removecompName: '',
      removeData: false,
      EcommList: [],
      CourierCompList: '',
      Cname: '',
      Otype: '',
      OtypeErr: '',
      ecomm: '',
      ecommError: false,
      isLoading: false,
      pickingtype: '',
      pickingsize: '',
      flag: '',
      defaultsize: '',
      tabIndex: 0,
      config: [],
      showBatch: true,
      showpickingsizeerror: '',
      showdefaultsizeerror: '',
      showpicksizeerror: '',
      showpickingtypeerror: '',
      showflagerror: '',
      localwarehouseid: '',
      pickingData: [],
      types: ["cluster", "batch"],
      assigntype: '',
      showassigntypeerror: '',
      rtoInscan: '',
      rtoInscanError: false,
      showSelectClient: false,
      showSelectWarehouse: false,
      clientListData: [],
      listWarehouseData: [],
      client: '',
      warehouse: '',
      ClientErr: '',
      WarehouseErr: '',
      roleid: '',
      searchFlag: false,
      sessiontime: '',
      audit: false,
      Tolerancepercentage: '',
      roleiderror: '',
      expcount: '',
      localclientid: 0,
      mrpExpFlag: false,
      expiryDayError: '',
      mrpAndExpiryFlag: false,
      outboundDisble: false,
      pickerDisable: false,
      rtoDisable: false,
      auditDisable: false,
      grcDisable: false,
      ecomDisable: false,
      mrpDisable: false,

      enableInvoice: false,
      selectedImageFile: '',
      custAcknowled: '',
      custAcknowledError: '',
      returnPolicy: '',
      returnPolicyError: '',
      tandc: '',
      tandcError: '',
      officeAddress: '',
      officeAddressError: '',
      ccphone: '',
      ccphoneError: '',
      ccemail: '',
      ccemailError: '',
      imageObject: [],
      logoname: '',
      editor: ClassicEditor,
      editorConfig: {},
      ecommxb: '',
      ecommErrorxb: false,
      partialorder: '',
      enableLabel: false,
      autoMatchError: '',
      autoMatch: '',
      maxval: '',
      autocreate: '',
      showautocreateerror: '',
      maximumvalue: '',
      showmaximumvalueerror: '',
      marketplace: '',
      marketplaceError: false,
      orderprocessing: '',
      orderprocessingError: false,
      reservestock: '',
      reservestockError: false,
      rackprefix: '',
      rackprefixError: false,
      rackError: '',
      manifestlimit: '',
      manifestError: false,
      smartrack: '',
      smartrackError: false,
      audittime: '',
      errorAuditHour: false,
      rackprefixtemp: '',
      multimerchant: '',
      multimerchantError: false,
      hasPrefix: false,
      excessqty: '',
      excessqtyError: '',
      excessprodqty: '',
      excessprodqtyError: '',
      enabledrcheck: '',
      enabledrcheckerror: '',
      pickqtysize: '',
      showpickqtysizeerror: '',
      pickflag: '',
      b2bqty: '',
      b2bqtyError: '',
      enablemultirackcheck: '',
      enablemultirackcheckerror: '',
      showpickflagerror: '',
      expiryThreshold: '',
      expiryThresholdError: false,
      returnThresholdDays: '',
      enablesubinvcheck: '',
      enablesubinvcheckerror: '',

      mySteps:['Create DR', 'GRC', 'PutAway','Complete'],
      currentStep:0,
      pono:'',
      listpodata:[],
      item:'',
      drno:'',
      createDRFlag: false,
      grcFlag: false,
      putawayFlag: false,
      submitFlag: false,
      selectedRow:{},
      listPOPutawayReportData:[],
      resultCount: 0,
      data: {
        labels: ['PO Qty', 'GRCAccepted', 'GRCRejected', 'AcceptedPutaway', 'RejectedPutaway'],
        datasets: [{
          label: 'Quantity',
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)'
          ],
          borderWidth: 1,
          data: [] 
        }]
      },
      options: {
        responsive: true
      },
      displayGraph: false,
      myStyles : {
          width: '500px',
          position: 'relative'
        }
    }
  },
  computed: {

  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.currentStep =0;
    var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')

    //this.getconfig();
    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        this.loginuserid = userdetail.userid;
        this.getClientList();
        this.getWarehouseList();
        break;

      case 'client_user':
        this.localclientid = userdetail.clientid;
        this.loginuserid = userdetail.userid;
        this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginuserid = userdetail.userid;
        this.localwarehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }

  },
  methods: {

    getWarehouseList() {
      if (window.localStorage.getItem("warehouseList") !== null) {
        var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
        var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
        var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
        this.listWarehouseData = JSON.parse(plaintextwarehouse);
      } else {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.isLoading = true;
        this.pageno = 0;

        this.input = ({
          clientid: this.localclientid,
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then(result => {
            this.isLoading = false;
            this.listWarehouseData = result.data.data;
          }, error => {
            console.error(error)
          })
      }

    },

    //to get Client list
    getClientList() {

      if (window.localStorage.getItem("clientList") !== null) {
        var clientListEncrypt = window.localStorage.getItem('clientList');
        var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        this.clientListData = JSON.parse(plaintextclient);
      } else {
        var userToken = window.localStorage.getItem('userToken');
        var myStr = userToken.replace(/"/g, '');
        this.pageno = 0;

        this.input = ({
          warehouseid: this.localwarehouseid,
        });
        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
          .then(result => {
            this.clientListData = result.data.data;
            this.isLoading = false;
          }, error => {
            console.error(error);
          });
      }

    },

    clientSelected() {
      if (this.localclientid != this.client) {
        this.localclientid = this.client;
        this.listWarehouseData = [];
        this.getWarehouseList();
        this.getPOList();
        if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
          this.warehouse = this.localwarehouseid = '';
        }
      }

      this.localclientid = this.client;
      this.b2bqty = '';

      if (this.localclientid) {

        if (this.localwarehouseid) {

          if (this.user_type != 'system_user') {
            this.searchFlag = true;
          } else {
            this.searchFlag = false;
          }

        } else {
          this.getWarehouseList();
        }
      }
    },
    getPOList(){

        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.isLoading = true;
        this.pageno = 0;

        this.input = ({
          clientid: this.localclientid,
          warehouseid: this.localwarehouseid
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getPoNo',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then(result => {
            this.isLoading = false;

            this.item = {
              value: '',
              text: ''
            };
            this.listpodata = [{
              value: '',
              text: 'Enter PO Number'
            }];
            result.data.forEach(ele => {
              this.listpodata.push({
                "value": ele.id,
                "text": ele.pono
              })
            })
          }, error => {
            console.error(error)
          })

    },

    warehouseSelected() {
      this.localwarehouseid = this.warehouse;
      if (this.localwarehouseid) {
        if (this.localclientid) {
          this.searchFlag = true;
        } else {
          this.getClientList();
        }
      }
    },
    onSelect(item) {

			this.item = item
			this.pono = item.text
		},

    onSubmit: function (event) {

      this.$validator
        .validateAll()
        .then(() => {
          console.log("form is valid", this.model);
          //event.target.reset();
        })
        .catch(() => {
          console.log("errors exist", this.errors);
        });
    },

    async getPODetails (){
      if(!this.localclientid){
        this.$alertify.error("Please select Client")
        return;
      }else{
        if(!this.localwarehouseid){
          this.$alertify.error("Please select Warehouseid")
          return;
        }else{
          if(!this.pono){
            this.$alertify.error("Please select PO NO.");
            return;
          }
        }
      }
      this.submitFlag = true;

      if(!this.localclientid){
        this.$alertify.error("Please select Client")
      }
			this.isLoading = true;
			this.input = ({
				clientid: this.localclientid,
				warehouseid: this.localwarehouseid,
				offset: 0,
				limit: 99999999,
				po: this.pono
			});
			let result = await common_helper.getRestApiResponse('POST', 'getMaterialInwardMaster', this.input, this.$alertify)
      if (result && !result.errorDATA) {
				this.isLoading = false;
        if(result.data.rows.length > 0 && result.data.rows[0].invreferenceid){
          this.selectedRow= result.data.rows[0];
          this.drno = result.data.rows[0].invreferenceid;
          this.createDRFlag = true;
          this.currentStep=1;
        }else{
          this.selectedRow={};
          this.drno = '';
          this.createDRFlag = false;
          this.$alertify.error("PO not Mapped, Create DR")
        }
			}
      else{
        this.selectedRow={};
        this.drno = '';
        this.createDRFlag = false;
        this.$alertify.error("Invalid Data")
      }
    },

    next(){
      if(this.submitFlag){
        this.currentStep>=4?4:this.currentStep++;
        if(this.currentStep === 2){
          this.getPOReportData()
        }
        if(this.currentStep === 3){
          this.getPOGraphData()
        }
      }
    },
    previous(){
      if(this.submitFlag){
        this.currentStep<=0?0:this.currentStep--;
      }
    },
    async getPOGraphData(){
      this.isLoading = true;
			this.input = ({
				clientid: this.localclientid,
				warehouseid: this.localwarehouseid,
				pono: this.pono
			});
			let result = await common_helper.getRestApiResponse('POST', 'getPOInboundChart', this.input, this.$alertify)
      if(result.data && result.data.length > 0){
        Object.entries(result.data[0]).forEach(([key, value]) => {
          this.data.datasets[0].data.push(Number(value));
      });
      this.displayGraph = true;
      }else{
        this.$alertify.error("Invalid Data")
      }
    },
    async getPOReportData(){
      this.listPOPutawayReportData = [];
      this.resultCount = 0
      this.isLoading = true;
			this.input = ({
        clientid: this.localclientid,
				warehouseid: this.localwarehouseid,
				pono: this.pono
			});
			let result = await common_helper.getRestApiResponse('POST', 'getPOInboundReport', this.input, this.$alertify)
      if(result.data){
        this.listPOPutawayReportData = result.data;
      }else{
        this.$alertify.error("Invalid Data")
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/xpressathon/xpressathon.component.js